import { render, staticRenderFns } from "./TCFDTocViewer.vue?vue&type=template&id=2fca2a75"
import script from "./TCFDTocViewer.vue?vue&type=script&lang=js"
export * from "./TCFDTocViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports